import { render, staticRenderFns } from "./SummaryInfo.vue?vue&type=template&id=3238cdde&"
import script from "./SummaryInfo.vue?vue&type=script&lang=ts&"
export * from "./SummaryInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports